<template>
	
<core-card-foot-stat :value="value" :count="count" type="rating" :text="field.label" />

</template>

<script>

export default {

	props: ['item', 'field'],

	computed: {

		value: function() {

			return this.item.game.rating_avg

		},

		count: function() {

			return this.item.game.rating_count

		}

	}

}

</script>

<style scoped>

</style>
